import * as yup from 'yup';

import { ETokenCode } from './constants';

export const NETWORKS_WITH_MEMO: string[] = [ETokenCode.XRP];
export const NUMBER_MEMO_NETWORKS: string[] = [ETokenCode.XRP];

export const memoWithNumbersValidationSchema = yup.number();
